var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1568: {
		fallback: () => (__webpack_require__.e(8).then(() => (() => (__webpack_require__(9008))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	11594: {
		fallback: () => (Promise.all([__webpack_require__.e(585), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(11163))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	18371: {
		fallback: () => (Promise.all([__webpack_require__.e(585), __webpack_require__.e(664)]).then(() => (() => (__webpack_require__(41664))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	69094: {
		fallback: () => (__webpack_require__.e(334).then(() => (() => (__webpack_require__(4298))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	44977: {
		fallback: () => (__webpack_require__.e(675).then(() => (() => (__webpack_require__(25675))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	58477: {
		fallback: () => (__webpack_require__.e(860).then(() => (() => (__webpack_require__(5152))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	68081: {
		fallback: () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(85893))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	25786: {
		fallback: () => (() => (__webpack_require__(67294))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	52491: {
		fallback: () => (__webpack_require__.e(623).then(() => (() => (__webpack_require__(89623))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	79739: {
		fallback: () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(96340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	87208: {
		fallback: () => (() => (__webpack_require__(89757))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/cache",

	},
	9316: {
		fallback: () => (() => (__webpack_require__(78265))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	57002: {
		fallback: () => (() => (__webpack_require__(71068))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.4.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/is-prop-valid",

	},
	19083: {
		fallback: () => (() => (__webpack_require__(92071))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.3.10",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@mui/system",

	},
	8344: {
		fallback: () => (() => (__webpack_require__(73326))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.3.10",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@mui/styled-engine",

	},
	21483: {
		fallback: () => (() => (__webpack_require__(92110))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	53554: {
		fallback: () => (() => (__webpack_require__(80138))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.3.10",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@mui/private-theming",

	},
	65206: {
		fallback: () => (() => (__webpack_require__(73935))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	8813: {
		fallback: () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(20745))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	54076: {
		fallback: () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(5152))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.4.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	22977: {
		fallback: () => (Promise.all([__webpack_require__.e(585), __webpack_require__.e(151)]).then(() => (() => (__webpack_require__(41664))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.4.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	37752: {
		fallback: () => (__webpack_require__.e(527).then(() => (() => (__webpack_require__(9008))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.4.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	69926: {
		fallback: () => (__webpack_require__.e(298).then(() => (() => (__webpack_require__(4298))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.4.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1568,11594,18371,69094,44977,58477,68081,25786,52491,79739,87208,9316,57002,19083,8344,21483,53554,65206,68081,25786,8813,65206,87208,9316,57002,19083,8344,21483,53554,54076];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"137": [
		1568,
		11594,
		18371,
		69094,
		44977,
		58477,
		68081,
		25786,
		52491,
		79739,
		87208,
		9316,
		57002,
		19083,
		8344,
		21483,
		53554,
		65206
	],
	"179": [
		68081,
		25786,
		8813,
		65206,
		87208,
		9316,
		57002,
		19083,
		8344,
		21483,
		53554
	],
	"606": [
		54076
	],
	"942": [
		22977,
		37752,
		69926
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}